module.exports = __webpack_public_path__ + "img/event3.293366d7.png";